import clsx from "clsx";
import { useNavigate } from "react-router-dom";
import React, { Dispatch, SetStateAction, useState } from "react";
import { Logo } from "../Logo";
import { isMobile } from "../../utils";
import { useAuth } from "../../contexts/AuthContext";
import { DrawerSider, LayoutSider, Module, Modules } from "./styles";
import { ReactComponent as DarfsIcon } from "../../assets/icons/sidebar/darfs.svg";
import { ReactComponent as ContaIcon } from "../../assets/icons/sidebar/conta.svg";
import { ReactComponent as ClientesIcon } from "../../assets/icons/sidebar/clientes.svg";
import { ReactComponent as AssessoresIcon } from "../../assets/icons/sidebar/assessores.svg";
import { RiFileDownloadLine } from "react-icons/ri";
import { MdOutlineLogout } from "react-icons/md";

interface ISideBarProps {
  pagePath: string;
}

interface ISideBarContainerProps {
  visible: boolean;
  setVisible: Function;
  expandedSidebar: boolean;
  setExpandedSidebar: Dispatch<SetStateAction<boolean>>;
}

const SideBarContainer: React.FC<ISideBarContainerProps> = ({
  children,
  visible,
  setVisible,
  expandedSidebar,
  setExpandedSidebar,
}) =>
  isMobile() ? (
    <DrawerSider
      title=""
      footer={null}
      width="192px"
      closeIcon={null}
      placement="left"
      visible={visible}
      onClose={() => setVisible(false)}
    >
      {children}
    </DrawerSider>
  ) : (
    <LayoutSider
      width="64px"
      theme="light"
      className={clsx({ expandedSidebar })}
      onMouseEnter={() => {
        setExpandedSidebar(true);
      }}
      onMouseLeave={() => {
        setExpandedSidebar(false);
      }}
    >
      {children}
    </LayoutSider>
  );

const Sidebar: React.FC<ISideBarProps> = ({ pagePath }) => {
  const navigate = useNavigate();
  const {
    user,
    signOut,
    showDrawer,
    setShowDrawer,
    expandedSidebar,
    setExpandedSidebar,
  } = useAuth();

  const [openKeys] = useState([""]);

  const handleNavigate = (path: string) => {
    if (path.includes("http")) {
      window.open(path, "_blank")?.focus();
    } else {
      setShowDrawer(false);
      navigate(path);
    }
  };

  return (
    <SideBarContainer
      visible={showDrawer}
      setVisible={setShowDrawer}
      expandedSidebar={expandedSidebar}
      setExpandedSidebar={setExpandedSidebar}
    >
     <Logo ext={expandedSidebar} />
      <Modules
        mode="inline"
        openKeys={openKeys}
        selectedKeys={[pagePath]}
        className={clsx("beauty-scrollbar zero-scrollbar", {
          user: !!user.user,
        })}
      >
        {user.user && (
          <Module
            key="/clients"
            onClick={() => handleNavigate("/clients")}
            icon={<ClientesIcon className="no-fill" />}
          >
            Clientes
          </Module>
        )}
        {user.user && (user.user.office || user?.user?.admin) && (
          <Module
            key="/professionals"
            onClick={() => handleNavigate("/professionals")}
            icon={<AssessoresIcon className="no-fill" />}
          >
            Assessores
          </Module>
        )}
        {user.user && (
          <Module
            key="/darf"
            onClick={() => handleNavigate("/darf")}
            icon={<DarfsIcon className="no-fill" />}
          >
            DARFs
          </Module>
        )}
        {user.user && (
          <Module
            key="/report"
            onClick={() => handleNavigate("/report")}
            icon={<RiFileDownloadLine size={23} style={{marginLeft: '1.3px'}} color="#E8E8E8"/>}
          >
            Relatórios
          </Module>
        )}
        {user.user && (
          <Module
            key="/conta"
            className="conta"
            icon={<ContaIcon className="no-fill" />}
            onClick={() => handleNavigate("/conta")}
          >
            Minha conta
          </Module>
        )}
        {user.user && (
          <Module
            key="/logout"
            className="logout"
            onClick={() => signOut()}
            icon={<MdOutlineLogout size={23} style={{marginLeft: '1.3px'}} color="#E8E8E8"/>}
          >
            Sair
          </Module>
        )}
      </Modules>
    </SideBarContainer>
  );
};

export default Sidebar;
